import { Badge, Box, Image } from '@chakra-ui/react';
import { ResponsiveValue } from '@chakra-ui/react';

const ImageWithBadge = ({
  src,
  w = 14,
  h = 14,
  quantity,
}: {
  src: string;
  w?: ResponsiveValue<string | number>;
  h?: ResponsiveValue<string | number>;
  quantity: number;
}) => {
  return (
    <Box w={w} h={h} bg="gray.200" borderRadius="md" position={'relative'}>
      <Badge
        position={'absolute'}
        top={-1}
        right={-1}
        bg="text.secondary"
        color={'text.white'}
        rounded={'full'}
        w={4}
        h={4}
        textAlign={'center'}
        zIndex={'2'}
        fontSize={'xs'}
        fontWeight={'normal'}
      >
        {quantity}
      </Badge>
      <Image
        src={src}
        w="full"
        h="full"
        objectFit={'cover'}
        objectPosition={'center 1px'}
        rounded={'md'}
        alt="image"
      />
    </Box>
  );
};

export default ImageWithBadge;
